import { render, staticRenderFns } from "./FaqNewPage.vue?vue&type=template&id=3a63355a"
import script from "./FaqNewPage.vue?vue&type=script&lang=ts"
export * from "./FaqNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports